// extracted by mini-css-extract-plugin
module.exports = {"minorMargin":"Form__minorMargin__Z2kTx","magorMargin":"Form__magorMargin__3hsgY"};